import { RouteConfig } from "vue-router";
const routes: Array<RouteConfig> = [
  {
    // rhinos隐私
    path: "/rhinos/user-agreement",
    name: "rhinosUserAgreement",
    component: () =>
      import(
        /* webpackChunkName: "rhinosUserAgreement" */ "@/views/rhinos/UserAgreement.vue"
      ),
  },
  {
    // rhinos隐私协议
    path: "/rhinos/privacy-policy",
    name: "rhinosPrivacyPolicy",
    component: () =>
      import(
        /* webpackChunkName: "rhinosPrivacyPolicy" */ "@/views/rhinos/PrivacyPolicy.vue"
      ),
  },
  {
    // rhinos帮助中心
    path: "/rhinos/help-center/detail",
    name: "rhinosHelpCenterDetail",
    component: () =>
      import(
        /* webpackChunkName: "rhinosHelpCenterDetail" */ "@/views/rhinos/QuestionDetail.vue"
      ),
  },
  {
    // rhinos帮助中心
    path: "/rhinos/help-center",
    name: "rhinosHelpCenter",
    component: () =>
      import(
        /* webpackChunkName: "rhinosHelpCenter" */ "@/views/rhinos/HelpCenter.vue"
      ),
  },
  {
    // rhinos分享详情
    path: "/rhinos/share",
    name: "rhinosShare",
    component: () =>
      import(
        /* webpackChunkName: "rhinosShare" */ "@/views/rhinos/Sharekey.vue"
      ),
    meta: {
      cname: "问题详情",
    },
  },
  // 智能解闭锁用户手册（使用指南）- 老版本，为了向前兼容
  {
    path: "/rhinos/intelligent-unlocking",
    name: "intelligentUnlocking",
    component: () =>
      import(
        /* webpackChunkName: "SmartLockerManual" */ "@/views/manual/SmartLockerManual.vue"
      ),
    meta: {
      cname: "智能解闭锁",
    },
  },
];
export default routes;
